import { ALLOW_ALL } from '$lib/services/auth/policies';
import { REG_PATH_EXCEPTION_HANDLER } from '$lib/services/auth/policy-exception-handler';

export const policy = ALLOW_ALL;

export const policyExceptionHandler = REG_PATH_EXCEPTION_HANDLER;
